<template>
  <div class="page">
    <div class="card">
      <div class="top">
        <div class="title">待提现余额(元)</div>
        <div class="rmb">¥ {{ walletInfo.balance || 0 }}</div>
      </div>
      <div class="bottom">
        <div class="item">
          <span class="key">累计提现金额</span>
          <span class="value">¥{{walletInfo.totalWithdrawalAmount || 0 }}</span>
        </div>
        <div class="item">
          <span class="key">退款冻结金额</span>
          <span class="value">¥{{walletInfo.freezeAmount || 0}}</span>
        </div>
      </div>
    </div>
    <div class="tips-box">
      提示: <br />
      一、关于待提现金额<br/>
      1.1 “待提现金额”是该商家所属门店的待提现金额汇总数;<br />
      1.2 待提现金额为微信平台扣除手续费后的金额;<br />
      1.3 待提现金额不包含“退款冻结金额”；<br />
      二、关于退款冻结金额<br />
      2.1 “退款冻结金额”是用户对“已核销”订单发起“退款申请”时，商家未处理退款订单时，系统对退款金额进行暂时“冻结”；<br />
      三、关于累计提现金额<br />
      3.1 “累计提现金额”是该商家所属门店所有已成功提现金额总和。<br />
      四、关于提现记录<br />
      4.1 查看历史“提现记录”， 点击左下角“记录”，即可查看。<br />
      五、关于提现<br />
      5.1 点击右下角“提现”，即可发起提现操作，提现金额不可大于“待提现金额”。<br />
    </div>
    <div style="height: 90px;"></div>
    <div class="footer">
      <div class="button" @click="to('/record')">记录</div>
      <div class="button bgd" @click="to('/withdrawal')">提现</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      walletInfo: {
        type: 0,
      },
      type: "binding",
    };
  },
  mounted() {
    this.getWalletInfo();
    // 监听绑定成功 重新初始化
    this.bus.$on("bindingSuccess", () => {
      this.getWalletInfo();
    });
  },
  methods: {
    to(path) {
      this.$router.push({
        path: path,
        query: {
          walletId: this.walletInfo.walletId,
          walletType: 1
        },
      });
    },
    // 获取钱包信息
    getWalletInfo() {
      this.$api.withdrawal.customerWalletInfo().then((res) => {
        if (res.data) {
          this.walletInfo = res.data
        }
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
  .page {
    padding: 15px;
    height: 100vh;
    overflow-y: auto;
    box-sizing: border-box;
    background: #fff;
    .card {
      min-height: 180px;
      border-radius: 13px;
      background: #F4F4F4;
      .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 133px;
        color: #fff;
        padding-left: 20px;
        box-sizing: border-box;
        background: url("https://img3.quanyou.com.cn/joyNew/group1/M00/46/D7/rB8LrmZZbxiAAXgDAADfGeLPI08949.png");
        background-size: 100% 100%;
        .title {
          font-size: 17px;
        }
        .rmb {
          font-weight: bold;
          font-size: 28px;
          margin-top: 6px;
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        padding: 14px;
        .item {
          font-size: 14px;
          .key {
            color: #666666;
            margin-right: 6px;
          }
          .value {
            color: #FF6B31;
            font-weight: bold;
          }
        }
      }
    }
    .tips-box {
      color: #999999;
      font-size: 14px;
      line-height: 22px;
      margin-top: 35px;
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 84px;
      background: #FFFFFF;
      box-shadow: 0px -3px 9px 0px rgba(220, 220, 220, 0.3);
      .button {
        width: 138px;
        height: 43px;
        font-size: 17px;
        color: #FF6B31;
        text-align: center;
        line-height: 43px;
        border-radius: 8px;
        border: 1px solid #FF6B31;
        margin-top: 10px;
      }
      .bgd {
        color: #FFFFFF;
        background: #FF6B31;
      }
    }
  }
</style>